import { html } from "lit";
import { getDummyText } from "../../../../utils";

export const magazineTeaserData = {
    headline: "Lorem ipsum dolor sit amet",
    text: getDummyText(300),
    icon: "application-bending",
    buttonText: "Zum Magazine",
    variant: "blue",
};

export const TeaserMagazineTemplate = (args) => html`
    <ux-iws-teaser-magazine
        variant="${args.variant}"
        icon="${magazineTeaserData.icon}"
        headline="${magazineTeaserData.headline}"
    >
        <div slot="text" class="ux-text-normal ux-u-mb-xs ux-u-mt-xxxs">
            ${magazineTeaserData.text}
        </div>
        <a slot="link" href="#" class="ux-button"
            >${magazineTeaserData.buttonText}</a
        >
    </ux-iws-teaser-magazine>
`;
